<template>
  <div style="margin-top: 24px;">
    <v-card :key="sa.id" class="mb-2" v-for="sa in results">
      <v-card-title>
        <v-layout row>
          <span class="headline mb-0">D/O #{{ sa.doNo }}-{{ sa.branchCode }}</span>
          <span class="ml-2 pt-2">{{ sa.status }}</span>
          <v-btn @click="cancelDo(sa)" v-if="sa.status ==='DO確定済'">DO取消</v-btn>
          <v-spacer/>
          <span>{{ sa.transportModeCode }}</span>
          <span class="ml-4">{{ sa.incotermCode }}</span>
          <span class="ml-4">{{ sa.loadingPortCode }}:{{ sa.loadingPortName }}</span>
          <span class="ml-2">→</span>
          <span class="ml-2">{{ sa.dischargePortCode }}:{{ sa.dischargePortName }}</span>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="sa.packages"
        :loading="loading"
        hide-actions
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <td width="150">{{ sa.blNo }}</td>
          <td width="150">{{ props.item.invoiceNo }}</td>
          <td :style="diffStyle('poNo', props.item)" width="150">{{ props.item.poNo }}</td>
          <td width="200">{{ props.item.productCode }}:{{ props.item.productName }}</td>
          <td width="200">{{ props.item.skuCode }}</td>
          <td width="100">{{ props.item.paid === 1 ? '有償' : '無償' }}</td>
          <td width="100">{{ props.item.cartonStartNo }}-{{ props.item.cartonEndNo }}</td>
          <td width="100">{{ props.item.perCartonQty }}</td>
          <td :style="diffStyle('qty', props.item)" width="100">{{ props.item.totalQty }}</td>
          <td width="100">{{ props.item.currencyCode }}</td>
          <td :style="diffStyle('unitPrice', props.item)" width="100">{{ props.item.unitPrice }}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ['no'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'INV NO', value: 'invNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productName', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton', value: 'carton', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false }
      ],
      results: [],
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: []
    }
  },
  methods: {
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    highlight(type, fields) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
    }
  },
  mounted() {
    this.loading = true
    this.$http.get(`/delivery-orders/conflict-inv?no=${this.no}`).then(res => {
      this.results = res.data
      this.results.forEach(sa =>
        sa.packages.sort((a, b) => (b.poNo || '').localeCompare(a.poNo || ''))
      )
      this.loading = false
    })
  },
  computed: {
    mappedByInvoiceNo() {
      const map = new Map()
      this.results.forEach(pkg => {
        if (!map.has(pkg.invoiceNo)) {
          map.set(pkg.invoiceNo, [])
        }
        map.get(pkg.invoiceNo).push(pkg)
      })
      return Array.from(map)
    }
  }
}
</script>

